/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.flujos': 'Flujos',
  'flujos.agregarFlujos': 'Crear Flujos',
  'flujos.modificarFlujos': 'Editar Flujos',
  'flujos.flujoId': 'Flujo Id',
  'flujos.empresaId': 'Empresa Id',
  'flujos.flujoDescripcion': 'Flujo Descripción',
  'flujos.VerFlujos': 'Ver Flujos',
};
